import { TSpellInfo } from './spellTypes';

export interface IBaseTraitNode<
  TTraitNodeType extends number = number,
  TTraitNodeEntry extends IBaseTraitNodeEntry = IBaseTraitNodeEntry
> {
  id: number; // primary id of node
  treeId: number; // the trait tree it is a part of
  subTreeId?: number; // the trait subtree it is a part of
  type: TTraitNodeType; // for knowing if this is a choice node or not
  entries: TTraitNodeEntry[]; // effectively just the spells
  important: boolean; // whether to include this in the set of highlighted nodes

  // we can perhaps use these to render a representation of the talent tree
  posX: number;
  posY: number;

  // computed row and column for the talent
  row: number; // low rows = bottom, high rows = top
  col: number;

  childrenNodeIds?: number[];

  flags?: number;
}

export interface IBaseTraitNodeEntry<TTraitNodeEntryType extends number = number> {
  id: number;
  traitDefinitionId: number;
  type: TTraitNodeEntryType;
  maxRanks: number;
  spell: TSpellInfo | null;

  traitSubTreeId?: number;
}

export interface IBaseChosenTraitNode<TTraitNode extends IBaseTraitNode = IBaseTraitNode> {
  node: TTraitNode;
  entryIndex: number;
  rank: number;
  grantedNode?: boolean;
}

export interface IOptionalChosenTraitNode<TTraitNode extends IBaseTraitNode = IBaseTraitNode> extends Pick<
  IBaseChosenTraitNode<TTraitNode>,
  'node'
> {
  entryIndex?: number;
  rank?: number;
  grantedNode?: boolean;
}
export type TEntryNode = {
  bitWidth: number; // bit width
  value: number; // number value
};

export enum ECommonTraitNodeType {
  Single = 0,
  Tiered = 1,
  Selection = 2,
  SubTreeSelection = 3
}
